!function(e){e.fn.moreMenu=function(t){var n=this,i=null,r=null,o=null,m=0,_=0;this.menu_items=[];var s=e.extend({verb:{more_link:'<a href="#">More...</a>'},more_menu_location:"inside_more_item",class_target:"more_menu",menu_item:"> li",extra_offset:0,check_for_resize:!1},t);function u(t){return e(t).outerWidth(!0)}return this.throttle=function(e,t,n){var i,r;return t||(t=250),function(){var o=n||this,m=+new Date,_=arguments;i&&m<i+t?(clearTimeout(r),r=setTimeout(function(){i=m,e.apply(o,_)},t)):(i=m,e.apply(o,_))}},this.refresh_menu_items=function(){n.menu_items=[],e(s.menu_item,n).each(function(){e(this).hasClass("more-menu-link")||n.menu_items.push({$el:this,width:u(this)})})},this.move_unfitting_items=function(){var t=e(n).width(),o=t-m-s.extra_offset,u=0;if(_!=t){_=t;for(var a=0;a<n.menu_items.length;a++){var c=n.menu_items[a],l=e(c.$el),h=c.width;u+h>o?l.appendTo(i):l.appendTo(n),u+=h}n.check_more_menu_link_visibility(),r.appendTo(n),n.trigger("on_update",[n])}},this.clear_more_menu=function(){i.html("")},this.create_more_menu=function(){return i=jQuery('<ul class="more-menu" />'),"after_menu"==s.more_menu_location?i.insertAfter(n):"inside_more_item"==s.more_menu_location||i.appendTo(s.more_menu_location),i},this.check_more_menu_link_visibility=function(){i.children().length?r.show():(r.hide(),n.show_hide_more_menu("hide"))},this.show_hide_more_menu=function(t){switch(t){case"show":e(o).addClass("more-menu-active");break;case"hide":e(o).removeClass("more-menu-active");break;case"toggle":e(o).toggleClass("more-menu-active")}},this.create_more_menu_link=function(){var e;(r=jQuery('<li class="more-menu-link"></li>')).html((e="more_link",s.verb[e])),r.appendTo(n),"inside_more_item"==s.more_menu_location&&i.appendTo(r),m=u(r),r.find("> a").on("click",function(e){e.preventDefault(),n.show_hide_more_menu("toggle"),n.trigger("on_show_toggle",[n])})},this.set_class_target=function(){o="more_menu"==s.class_target?n:s.class_target,e(o).addClass("mm-initialized")},this.check_for_resizing=function(){s.check_for_resize&&e(document).on("resize",n.throttle(n.move_unfitting_items,100))},n.set_class_target(),n.create_more_menu(),n.create_more_menu_link(),n.refresh_menu_items(),n.move_unfitting_items(),n.check_for_resizing(),n.trigger("on_creation",[n]),n}}(jQuery);

const $win = $(window);
const $doc = $(document);

function readMoreNav() {
	let $menu = $('.nav .main-menu').clone();

	$('.nav .main-menu .menu').moreMenu({
		check_for_resize: true
	});

	let timeout;
	$win.on('resize', function() {
		clearTimeout(timeout);
		timeout = setTimeout(function() {
			$('.nav .main-menu').empty().append($menu.html());
			$('.nav .main-menu .menu').moreMenu({
				check_for_resize: true
			});
		}, 10)
	})

}

$('.nav .menu > .menu-item-has-children').each(function() {
    $(this).find('ul').each(function() {
    	const $this = $(this);
        const parentCount = $this.parentsUntil('.menu', 'ul').length + 1;
        $this.parent().addClass('menu-deep-' + parentCount)
    })
})


$('.nav .menu > .menu-item-has-children').each(function() {
	const $this = $(this);
	const dropDownCount = $this.find('.sub-menu').length;
	if (dropDownCount > 1) {
		$this.addClass('megamenu');
	}
})


if ($win.width() > 1080) {
	readMoreNav();
}

$('.nav').on('click', '.menu-item-has-children > a', function(e) {
	const $this = $(this);
	if ($this.closest('.more-menu').length == 0 && $win.width() > 1080) {
		e.preventDefault();
		$this.parent().toggleClass('active').find('.dropdown:eq(0)').stop(true,true).fadeToggle(100);
		$('.nav .menu-item-has-children.active').not($this.parent()).removeClass('active');
		$('.nav .menu-deep-1').not($this.parent().find('.dropdown:eq(0)')).stop(true,true).fadeOut(100);
		$('.more-menu-link').removeClass('active').find('.more-menu').stop(true,true).fadeOut(100);
	}
}).on('click', '.more-menu-link > a', function(e) {
	if ($win.width() > 1080) {
		e.preventDefault();
		$('.more-menu').fadeToggle(100);
		$('.nav .menu-deep-1').stop(true,true).fadeOut(100);
		$(this).parent().toggleClass('active').siblings().removeClass('active');
	}
})



// WEBPACK FOOTER //
// ./../src/assets/js/menu.js